import PropTypes from "prop-types";
import { Controller, useFormContext } from "react-hook-form";
import { TextField as MuiTextField } from "@mui/material";

const NumberField = ({
  name,
  label,
  required = false,
  helperText: _helperText,
  disabled = false,
  fullWidth = false,
  variant = "outlined",
  size = "medium",
  min,
  max,
  step = 1,
  ...rest
}) => {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState }) => (
        <MuiTextField
          {...field}
          value={field.value ?? ""}
          onChange={(e) => {
            const value = e.target.value === "" ? "" : Number(e.target.value);
            field.onChange(value);
          }}
          type="number"
          label={label}
          required={required}
          error={!!fieldState.error}
          helperText={fieldState.error?.message}
          disabled={disabled}
          fullWidth={fullWidth}
          variant={variant}
          size={size}
          inputProps={{
            min,
            max,
            step,
          }}
          {...rest}
        />
      )}
    />
  );
};

NumberField.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  required: PropTypes.bool,
  helperText: PropTypes.string,
  disabled: PropTypes.bool,
  fullWidth: PropTypes.bool,
  variant: PropTypes.oneOf(["outlined", "filled", "standard"]),
  size: PropTypes.oneOf(["small", "medium"]),
  min: PropTypes.number,
  max: PropTypes.number,
  step: PropTypes.number,
};

export default NumberField;
